module.exports = __webpack_public_path__ + "img/logo.86c42a06.svg";